import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions} from '@angular/http';

import {ConfigService} from './config.service';
import {LogService} from './log.service';


@Injectable()
export class ReviewerImageService {
	constructor(
		private http: Http,

		private config: ConfigService,
		private log: LogService
	) {}


	uploadImage(fileList: FileList, filmId: string) {
		return new Promise((resolve, reject) => {
			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			headers.append('Accept', 'application/json');
			let options = new RequestOptions({ headers: headers });

			let file: File = fileList[0];
			let formData = new FormData();
			formData.append('imagefile', file, file.name);

			this.http.post(this.config.basePath + '/v0/films/' + filmId + '/image', formData, options)
				.toPromise()
				.then((res: any) => {
					let foo = res.json();
					resolve(foo);
				})
				.catch((err: any) => {			// this is a Response object, with res.status === 401, for example
					// TODO - handle errors?
					this.log.error(err);
					reject();
				});
		});
	}
}



// WEBPACK FOOTER //
// /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/reviewer-image.service.ts